// Админ не считается в аналитике (25.10.2026): /admin и браузер вошедшего
// админа. Отдельный модуль без import.meta.env — его читают ev() главной и
// карты (home-events.ts) и проверки вне Vite. Подробности — src/lib/analytics/index.ts.

export const ADMIN_MUTE_KEY = "yt_admin_no_analytics";

/** Этот просмотр в аналитику не идёт: /admin или браузер вошедшего админа. Никогда не бросает. */
export function isAnalyticsMuted(): boolean {
  if (typeof window === "undefined") return true;
  try {
    if (/^\/admin(\/|$)/.test(window.location.pathname)) return true;
    return window.localStorage.getItem(ADMIN_MUTE_KEY) === "1";
  } catch {
    return false;
  }
}
